import React from 'react';
import { Button } from 'components/quashed';
import styles from './styles/SessionExpiredContainer.module.scss';
import { useAuth0 } from '../../react-auth0-spa';
import Logo from 'components/logo';

const SessionExpiredContainer = () => {
  const { logout } = useAuth0();

  return (
    <div className={styles.container}>
      <nav className={styles.nav}>
        <Logo />
      </nav>

      <div className={styles.content}>
        <img
          className={styles.image}
          alt="Session expired"
          src={`${MARKETING_SITE_URL}/images/auth/session-expired.webp`}
        />
        <div className={styles.subtitle}>Session has expired</div>
        <h1 className={styles.title}>Continue to log in</h1>

        <Button className={styles.submit} text="Continue" onClick={logout} />
      </div>
    </div>
  );
};

export default SessionExpiredContainer;
